import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../db/StorageService';

export type AppLanguage = 'en-US' | 'es';

export const DEFAULT_LANGUAGE: AppLanguage = 'en-US';
export const SUPPORTED_LANGUAGES: ReadonlyArray<AppLanguage> = ['en-US', 'es'];

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly storageService = inject(StorageService);
  private readonly translateService = inject(TranslateService);
  private readonly storeKey = 'language';

  // Snapshot síncrono del idioma activo (para inicializar controles de UI
  // sin esperar al storage, igual que el toggle de tema lee <body>).
  currentLanguage(): AppLanguage {
    const lang = this.translateService.getCurrentLang() as AppLanguage | null;
    return lang && SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  }

  setLanguage(lang: AppLanguage): Promise<void> {
    this.translateService.use(lang);
    return this.saveLanguage(lang);
  }

  saveLanguage(lang: AppLanguage): Promise<void> {
    return this.storageService.store(this.storeKey, lang);
  }

  getLanguage(): Promise<AppLanguage | null> {
    return this.storageService.findByKey(this.storeKey);
  }

  // Aplica el idioma persistido una sola vez (arranque de la app), con
  // fallback al default (en-US) si no hay nada guardado o el valor es inválido.
  async applyLanguage(): Promise<void> {
    const stored = await this.getLanguage();
    const lang =
      stored && SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
    this.translateService.use(lang);
  }
}
